import { SignIn, useUser } from "@clerk/react";
import { Redirect, useLocation, useSearch } from "wouter";
import { isStaffUser, isStaffDevOverrideEnabled } from "@/lib/staff";
import {
  STAFF_HOME_PATH,
  staffForceRedirectUrl,
  staffSignInLocation,
} from "@/lib/staff-return-path";

export function ProtectedStaffRoute({
  component: Component,
  basePath = "",
}: {
  component: React.ComponentType;
  basePath?: string;
}) {
  const { isLoaded, isSignedIn, user } = useUser();
  const [location] = useLocation();

  if (!isLoaded) {
    return null;
  }

  if (!isSignedIn) {
    return (
      <Redirect
        to={staffSignInLocation(location, window.location.search, basePath)}
        replace
      />
    );
  }

  if (!isStaffUser(user) && !isStaffDevOverrideEnabled()) {
    return <Redirect to="/" />;
  }

  return <Component />;
}

export function StaffSignIn({ basePath = "" }: { basePath?: string }) {
  const search = useSearch();
  const forceRedirectUrl = staffForceRedirectUrl(search, basePath);
  return (
    <SignIn
      routing="path"
      path={`${basePath}/sign-in`}
      signUpUrl={`${basePath}/sign-up`}
      forceRedirectUrl={forceRedirectUrl}
      fallbackRedirectUrl={`${basePath}${STAFF_HOME_PATH}`}
    />
  );
}
